import React from 'react'
import PropTypes from 'prop-types'
// import Helmet from 'react-helmet'


import Background from "../img/cover.jpg";
import Logo from "../img/logo-k.png";
// import Scroller from "../components/scroller"
import Menu from "../components/menu"
import Map from "../components/map"
// import InstaPics from "../data/instagram-leads"
// import RenderImages from "../components/insta"
import Burger from "../components/burger"
import Navigation from "../components/navigation"
import AboutUs from "../components/aboutus"
import Opentable from "../components/opentable";
import './index.css'


const TemplateWrapper = ({ children }) => (


  <div id="outer-container" style={{ height: '100%', width: '100vw', maxWidth: '100%' }}>
    <main id="page-wrap">
      <div className="landing-layout">
        <div className="landing-layout__blur">
          <div style={{
            backgroundImage: "url(" + Background + ")",
            backgroundRepeat: 'no-repeat',
            height: '100vh',
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            zIndex: '1',
          }}>
          </div>
        </div>
      </div>

      <div style={{
        position: 'absolute',
        width: '100vw',
        maxWidth: '100%',
        height: '100vh',
        top: '0',
        left: '0',
        zIndex: '1000',
        display: 'flex',
        flexDirection: 'column',
      }}>
        <Burger />
        <Navigation />




        {children()}
      </div>
      <Opentable />

      <AboutUs />
      <Menu />

      {/* <RenderImages/> */}

      <Map />

    </main>


  </div>
);


TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js